<ng-template #customHeader><app-user-profile class="flex"></app-user-profile></ng-template>
<ng-template #sideNav><app-sidebar></app-sidebar></ng-template>

<gcm-app [headerProfile]="customHeader" [sideNavContent]="sideNav"></gcm-app>